import React, { useState } from 'react'
import Typography from '@mui/material/Typography'
import Select, { components } from 'react-select'
import CreatableSelect from 'react-select'
import clsx from 'clsx'

import { useIntl } from 'react-intl'

import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import FieldWrapper from '../FieldRowWrapper'
import { ButtonSpinner } from '../../GeneralComponents/Loading/CustomeLoader'
import RawHtml from 'stories/components/RawHtml'
import useStyles from './style'

import './dropdown.css'

const CustomOption = (props) => {
  const classes = useStyles()
  const { data, innerRef, innerProps } = props
  if (data.loading) return <ButtonSpinner size={20} />
  if (data.custom)
    return (
      <div
        ref={innerRef}
        className={classes.customOption}
        {...innerProps}
        onClick={data.onClick}
      >
        {data.label}
      </div>
    )
  return <components.Option {...props} />
}

const SelectInput = ({
  label = '',
  options = [],
  name,
  required,
  touched,
  error,
  description,
  placeholder,
  labelKey = 'title',
  valueKey = 'slug',
  value,
  customized,
  isMulti,
  isSearchable,
  isClearable,
  customNoOptionsMessage,
  customEmptyListMessage,
  styles,
  disabled,
  alwaysEnableLabel,
  ...props
}) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const [hasFocus, setFocus] = useState(false)
  const [userCreatedOptions, setUserCreatedOptions] = useState([])

  function formattedOptions() {
    // send null to enable loading during fetching list
    if (!options) return [{ value: '', label: '', loading: true }]
    // format list
    return options.map((option) => ({
      value: option.value || option[valueKey],
      label: option.label || option[labelKey],
      onClick: option.onClick || null,
      custom: option.custom || false,
      color: option.color,
    }))
  }

  const onInputFocus = () => {
    setFocus(true)
    props.onFocus && props.onFocus()
  }

  const onInputBlur = () => {
    setFocus(false)
    props.onBlur && props.onBlur()
  }

  const handleNewOption = ({ label, value }) => {
    setUserCreatedOptions([{ label, value }, ...userCreatedOptions])
  }

  const customEmptyList = (data, value) => (
    /*
    data obj structure :
    {
    custom: true,
    slug: 'none',
    [labelKey]: title,
    onClick: () => {
      addNewProduct(true);
    },
  };
    */

    <div
      className={classes.customOption}
      onClick={() => {
        data.onClick(value)
      }}
    >
      {data[labelKey]}
    </div>
  )
  const renderArrayOptions = (options) => {
    return options.map((option) => ({
      label: option.label || option[labelKey],
      value: option.value || option[valueKey],
      color: option.color,
    }))
  }

  const renderValue = () => {
    if (typeof value === 'object') {
      if (Array.isArray(value)) return renderArrayOptions(value)
      if (value === null) return ''
      return {
        value: value[valueKey],
        label: value[labelKey],
        color: value.color,
      }
    }
    if (value === '') return ''
    if (formattedOptions()) {
      return formattedOptions().find((option) => option.value === value)
    }
    return ''
  }

  const generateValue = (option) => {
    if (option) {
      if (!Array.isArray(option)) return option.value
      return option
    }
    return ''
  }

  const onInputChange = (option) => {
    props.onChange(generateValue(option))
  }

  const renderLabel = () => {
    if (alwaysEnableLabel) return true
    if (label && Array.isArray(value) && value.length === 0) return false
    if (label && value) return true
    return false
  }

  const classNames = {
    'formz-dropdown-input': true,
    'formz-has-focus': hasFocus,
    'formz-has-error': error,
    'full-width': props.fullWidth,
  }
  const SelectProps = {
    name,
    value: renderValue(),
    options: formattedOptions(),
    autosize: false,
    placeholder:
      placeholder || formatMessage({ id: 'form.fields.dropDown.placeholder' }),
    onBlur: onInputBlur,
    onFocus: onInputFocus,
    onChange: onInputChange,
    onNewOptionClick: handleNewOption,
    error,
    isSearchable,
    isClearable,
    components: { Option: CustomOption },
    isMulti,
    disabled,
    noOptionsMessage: (value) => {
      return customNoOptionsMessage
        ? customEmptyList(customNoOptionsMessage, value)
        : formatMessage({
            id: customEmptyListMessage || 'general.dropdown.empty',
          })
    },
  }

  if (customized)
    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <label className="formz-field-and-label-holder">
          <div className="formz-input-title">
            {label} {required && '(*)'}
          </div>

          <RawHtml className="formz-field-description" content={description} />

          {props.dontAllowOptionCreation ? (
            <Select {...SelectProps} className="Select" />
          ) : (
            <CreatableSelect
              {...SelectProps}
              classNamePrefix="Select"
              className="Select"
            />
          )}
        </label>
      </FieldRowWrapper>
    )
  return (
    <FieldWrapper
      error={error}
      touched={touched ? touched.toString() : undefined}
      fullWidth={props.fullWidth}
    >
      <div className={classes.select}>
        {renderLabel() && (
          <Typography
            variant="caption"
            component="div"
            className={`${classes.label} select-label`}
          >
            {label}
          </Typography>
        )}

        <Select
          {...SelectProps}
          isDisabled={disabled}
          styles={styles}
          className={clsx({
            [classes.error]: Boolean(error),
          })}
          classNamePrefix="Select"
        />
      </div>
    </FieldWrapper>
  )
}

class SelectDropdownInput extends React.Component {
  render() {
    return <SelectInput {...this.props} />
  }
}
export default SelectDropdownInput
